import { useRouter } from 'src/routes/hooks';

import axios from 'src/utils/axios';
import confetti from 'src/utils/confetti';

import { useDispatch } from 'src/state';
import { useTranslate } from 'src/locales';
import { dataPopupClosed } from 'src/state/subscription/actions';

import { toast } from 'src/components/snackbar';

export default function Bridge() {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const router = useRouter();

  (window as any).dataPopupClosed = (data: any) => {
    dispatch(dataPopupClosed(data.id, data.reference));
    console.log('Data popup closed:', data);
    confetti();
  };

  (window as any).Lumi = {
    getSignedUploadUrl(
      name: string,
      type: string,
      size: string,
      callback: (response: any, error: any) => void
    ) {
      axios
        .post(`/api/v1/h5p/upload/signedUploadUrl/editor`, {
          name,
          type,
          size,
        })
        .then((response) => {
          callback(null, response.data);
        })
        .catch((error: any) => {
          callback(error, null);
        });
    },
    trigger: (event: string) => {
      switch (event) {
        case 'upload-failed-not-subscribed':
          toast.error(
            t('File is too large. Please subscribe to Lumi Pro to increase the file limit size.'),
            {
              duration: Infinity,
              action: {
                label: t('Subscribe'),
                onClick: () => {
                  router.push('/dashboard/user/account/subscription');
                },
              },
              cancel: {
                label: t('Dismiss'),
                onClick: () => {},
              },
            }
          );
          break;
        default:
          toast.warning(t('Unknown error occurred.'));
      }
    },
  };

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}
